// import React, { Component } from 'react';
// import PropTypes from 'prop-types';
// import { findDOMNode } from 'react-dom';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
// import {
//   DragSource,
//   DropTarget
// } from 'react-dnd';
// import flow from 'lodash/flow';

// import './styles/styles.css';

// const style = {
//   paddingLeft: 55
// };

// const cardSource = {
//   beginDrag(props) {
//     return {
//       id: props.id,
//       index: props.index,
//     }
//   },
// };

// const cardTarget = {
//   hover(props, monitor, component) {
//     const dragIndex = monitor.getItem().index
//     const hoverIndex = props.index

//     // Don't replace items with themselves
//     if (dragIndex === hoverIndex) {
//       return;
//     }

//     // Determine rectangle on screen
//     const hoverBoundingRect = (findDOMNode(
//       component,
//     )).getBoundingClientRect();

//     // Get vertical middle
//     const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;

//     // Determine mouse position
//     const clientOffset = monitor.getClientOffset();

//     // Get pixels to the top
//     const hoverClientY = (clientOffset).y - hoverBoundingRect.top;

//     // Only perform the move when the mouse has crossed half of the items height
//     // When dragging downwards, only move when the cursor is below 50%
//     // When dragging upwards, only move when the cursor is above 50%
//     // Dragging downwards
//     if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
//       return;
//     }

//     // Dragging upwards
//     if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
//       return;
//     }

//     // Time to actually perform the action
//     props.moveCard(dragIndex, hoverIndex);

//     // Note: we're mutating the monitor item here!
//     // Generally it's better to avoid mutations,
//     // but it's good here for the sake of performance
//     // to avoid expensive index searches.
//     monitor.getItem().index = hoverIndex;
//   },
// }

// class SortableItem extends Component {
//   static propTypes = {
//     connectDragSource: PropTypes.func.isRequired,
//     connectDropTarget: PropTypes.func.isRequired,
//     index: PropTypes.number.isRequired,
//     isDragging: PropTypes.bool.isRequired,
//     id: PropTypes.any.isRequired,
//     text: PropTypes.string.isRequired,
//     moveCard: PropTypes.func.isRequired,
//   }

//   render() {
//     const {
//       text,
//       isDragging,
//       connectDragSource,
//       connectDropTarget,
//     } = this.props;
//     const opacity = isDragging ? 0 : 1;

//     return (
//       <div style={{ ...style, opacity }} className={this.props.className}>
//         {this.props.children}
//         {
//           connectDragSource &&
//           connectDropTarget &&
//           connectDragSource(
//             connectDropTarget(
//               <div className="sortable-icon-handler">
//                 <FontAwesomeIcon icon='arrows-alt-v' className='icon' />
//               </div>
//             )
//           )
//         }
//       </div>
//     );
//   }
// }

// export default flow(
//   DragSource(
//     'card',
//     cardSource,
//     (connect, monitor) => ({
//       connectDragSource: connect.dragSource(),
//       isDragging: monitor.isDragging(),
//     }),
//   ),
//   DropTarget('card', cardTarget, (connect) => ({
//     connectDropTarget: connect.dropTarget(),
//   }))
// )(SortableItem);
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'
import './styles/styles.css'
import { faArrowsAltV } from '@fortawesome/free-solid-svg-icons'

const style = {
	paddingLeft: 55,
}

class SortableItem extends Component {
	static propTypes = {
		index: PropTypes.number.isRequired,
		id: PropTypes.any.isRequired,
		text: PropTypes.string.isRequired,
		moveCard: PropTypes.func.isRequired,
	}

	render() {
		const { text, connectDraggable, connectDroppable } = this.props

		return (
			<div
				ref={(ref) => connectDraggable(ref)}
				{...this.props.draggableProps}
				{...this.props.dragHandleProps}
				style={{ ...style }}
				className={this.props.className}
			>
				{this.props.children}
				<div ref={(ref) => connectDroppable(ref)}>
					<div className='sortable-icon-handler'>
						<FontAwesomeIcon icon={faArrowsAltV} />
					</div>
				</div>
			</div>
		)
	}
}

class SortableList extends Component {
	static propTypes = {
		items: PropTypes.array.isRequired,
		onSortEnd: PropTypes.func.isRequired,
	}

	render() {
		const { items, onSortEnd } = this.props

		return (
			<DragDropContext onDragEnd={onSortEnd}>
				<Droppable droppableId='droppable'>
					{(provided, snapshot) => (
						<div {...provided.droppableProps} ref={provided.innerRef}>
							{items.map((item, index) => (
								<Draggable key={item.id} draggableId={item.id} index={index}>
									{(provided, snapshot) => (
										<SortableItem
											index={index}
											id={item.id}
											text={item.text}
											moveCard={this.props.moveCard}
											connectDraggable={provided.innerRef}
											connectDroppable={provided.innerRef}
											draggableProps={provided.draggableProps}
											dragHandleProps={provided.dragHandleProps}
										/>
									)}
								</Draggable>
							))}
							{provided.placeholder}
						</div>
					)}
				</Droppable>
			</DragDropContext>
		)
	}
}

export default SortableList
